module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/sorority-collab-large-97a010f0bb23214ba76280a7d58e8e8e.jpg";